import fetchInterceptor,{FetchOptions} from "../../../utils/fetchInterceptor ";
// import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor";
import { blogEndpoints } from "../apiEndpoints";
import { header } from "../../../context/constant";

const AddBlogAPI = async (blogData: FormData) => {
  const url = blogEndpoints.add();
  const options: FetchOptions = {
    method: "POST",
    body: blogData, // Pass the FormData object directly
  };
  return fetchInterceptor(url, options);
};

export default AddBlogAPI;
